module.exports = __webpack_public_path__ + "img/w-public-relations.2f5700ed.svg";